var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import styles from './styles.module.css.json';
export function FieldGroup(_a) {
    var children = _a.children, className = _a.className, otherProps = __rest(_a, ["children", "className"]);
    var classNames = cn(styles.FieldGroup, className);
    return (React.createElement("div", __assign({}, otherProps, { className: classNames }), React.Children.map(children, function (child) { return (React.createElement("div", { className: styles.FieldGroup__item }, child)); })));
}
//# sourceMappingURL=index.js.map